import { useQuery } from "react-query";
import useDebounce from "../../lib/useDebounce";
import axiosClient from "../../lib/axios";
import { IDataPublicos } from "../../types/api/geral/pesquisar-publicos";
import { useMemo } from "react";
import { Autocomplete, TextField } from "@mui/material";

export default function PublicosAutoComplete({
    valor,
    dado,
    onChangeDados,
    onChangeLabel
}: PublicosAutoCompleteProps) {

    const debouncedKeyword = useDebounce(valor)

    //queries e mutations
    const { data, isFetching: carregandoPublicos } = useQuery({
        queryKey: ['pesquisar-publicos', debouncedKeyword],
        queryFn: () => axiosClient.get("/pesquisar-publicos", {
            params: {
                limit: 50,
                page: 1,
                pesquisar: debouncedKeyword
            }
        }),
        cacheTime: 0,
        keepPreviousData: true,
        refetchOnWindowFocus: false
    });
    const dataClientes: IDataPublicos[] = useMemo(() => data?.data.data || [], [data])
    //

    return (
        <Autocomplete
            disablePortal
            fullWidth
            options={dataClientes.map((i) => ({
                label: `${i.tipo_publico}-${i.codigo_publico} / ${i.nome_pessoa}`,
                dado: { ...i }
            }))}
            onChange={(_: any, newValue: any) => {
                onChangeDados(newValue?.dado ?? null)
                onChangeLabel(newValue?.label ?? "")
            }}
            value={{
                label: valor,
                dado: dado
            }}
            loading={carregandoPublicos}
            loadingText="Carregando..."
            noOptionsText={carregandoPublicos ? "Carregando..." : "Sem resultados"}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label="Público"
                    value={valor}
                    onChange={(e) => onChangeLabel(e.target.value)}
                />
            )}
        />
    )
}

interface PublicosAutoCompleteProps {
    valor: string,
    dado: IDataPublicos | null,
    onChangeDados: (dados: IDataPublicos) => void
    onChangeLabel: (label: string) => void
}